import { UserTypeEnums } from '@/GlobalEnums/enums';
import useUserDetails from '@/store/userDetails';
import { useRouter } from 'next/router';

export default function usePostLoginRedirection() {
  const router = useRouter();
  const { userDetails } = useUserDetails();
  const goToDashoboard = async () => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('shouldUserRedirectToDashboard', 'true');
    }
    if (userDetails?.profileId?.userType === UserTypeEnums.NO_BATCH)
      router.push('/dashboard/allCourses');
    else router.push((router.query.to as string) || '/dashboard/overview');
  };
  return {
    goToDashoboard,
  };
}
